import React, {
    memo, useLayoutEffect,
} from 'react';
import {
    AwardsBlock,
    Footer,
    Header,
    CrewMembersBlock,
    PortfolioBlock,
    FAQsBlock,
    DegustationBlock,
    ImagesBlock,
    ContactsBlock,
    NavigationBlock,
    Breadcrumb,
    PlacesBlock,
    Toolbar,
} from 'widgets';
import { useAppDispath, PageLayout, Error } from 'shared';
import { CateringPageActions, useCateringPageState } from '../store';
import { CateringPageMain } from './components/CateringPageMain';

const MemoBreadcrumb = memo(Breadcrumb);
const MemoFooter = memo(Footer);
const MemoAwardsBlock = memo(AwardsBlock);
const MemoPortfolioBlock = memo(PortfolioBlock);
const MemoPlacesBlock = memo(PlacesBlock);
const MemoFAQsBlock = memo(FAQsBlock);
const MemoDegustationBlock = memo(DegustationBlock);
const MemoImagesBlock = memo(ImagesBlock);
const MemoContactsBlock = memo(ContactsBlock);
const MemoNavigationBlock = memo(NavigationBlock);
const MemoMain = CateringPageMain;

export const CateringPage = () => {
    const {
        errors,

        cateringEventCategories,
        cateringFormats,
        cateringEventFormats,

        title,
        description,
        image,
        leadFormPdf,
    } = useCateringPageState();

    const dispatch = useAppDispath();

    useLayoutEffect(() => {
        dispatch(CateringPageActions.getCateringService());

        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    return (
        <PageLayout
            toolbar={<Toolbar />}
        >
            <Header />
            <MemoBreadcrumb />
            {errors.length === 0 ? (
                <MemoMain
                    cateringEventCategories={cateringEventCategories}
                    cateringFormats={cateringFormats}
                    cateringEventFormats={cateringEventFormats}
                    title={title}
                    description={description}
                    image={image}
                    leadFormPdf={leadFormPdf}
                />
            ) : (
                <Error
                    errors={errors}
                    margin="4rem 0"
                />
            )}
            <MemoAwardsBlock />
            <MemoImagesBlock />
            <MemoDegustationBlock />
            <CrewMembersBlock />
            <MemoPortfolioBlock />
            <MemoPlacesBlock />
            <MemoContactsBlock />
            <MemoFAQsBlock />
            <MemoNavigationBlock />
            <MemoFooter />
        </PageLayout>
    );
};
